<template>
  <!--  订单拣货-->
  <div class="OrderPicking">
    <div class="OrderPicking__left">
      <el-input v-model="filterText" placeholder="输入门店名称查询" class="wHP padding10"></el-input>
      <div class="flex1 scrollAuto scrollbar">
        <el-tree ref="tree" class="filter-tree" :data="storeList" :props="defaultProps" default-expand-all :filter-node-method="filterNode" @node-click="handleNodeClick"></el-tree>
      </div>
    </div>
    <div class="OrderPicking__right">
      <div class="fs20">订单拣货管理</div>
      <el-divider></el-divider>
      <div class="marginBottom10 flex flexSpaceBetween">
        <div class="flex alignItemsCenter border borderRadius5">
          <el-input v-model="input" clearable placeholder="门店名称/客户地址/备注/制单人" class="w300" @change="queryPageList">
            <i slot="suffix" class="el-input__icon el-icon-search pointer" @click="queryPageList"></i>
          </el-input>
        </div>
        <div>
          <el-button v-hasPermi="['order:orderPicking:pickCancel']" type="danger" size="medium" @click="handleCancelByIds">批量取消</el-button>
          <el-button type="primary" size="medium" @click="addPickingDialogVisible = true">拣货制单</el-button>
        </div>
      </div>
      <div class="flexGrow1">
        <el-table ref="multipleTable" height="700" :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column label="序号" align="center" type="index" width="55" />
          <el-table-column label="出货门店" align="left" header-align="center" prop="sstore" />
          <el-table-column label="客户地址" align="left" header-align="center" prop="ccustomerAddr" />
          <el-table-column label="检索单号" align="left" header-align="center" prop="sretrieval" />
          <el-table-column label="备注" align="center" prop="cremark" />
          <el-table-column label="状态" align="center" prop="state" width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.zstate === 1" style="color: grey">{{ scope.row.zstate | orderPickingState }}</span>
              <span v-else-if="scope.row.zstate === 2" style="color: #409eff">{{ scope.row.zstate | orderPickingState }}</span>
              <span v-else-if="scope.row.zstate === 3" style="color: green">{{ scope.row.zstate | orderPickingState }}</span>
              <span v-else-if="scope.row.zstate === 4" style="color: red">{{ scope.row.zstate | orderPickingState }}</span>
              <span v-else-if="scope.row.zstate === 5" style="color: blue">{{ scope.row.zstate | orderPickingState }}</span>
              <span v-else>{{ scope.row.zstate | orderPickingState }}</span>
            </template>
          </el-table-column>
          <el-table-column label="制单人" align="center" width="70" >
              <template slot-scope="scope">
                  <span v-if="scope.row.supdate !== undefined && scope.row.supdate !== ''">{{ scope.row.supdate }}</span>
                  <span v-else>{{ scope.row.screate }}</span>
              </template>
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="saudit" />
          <el-table-column label="制单时间" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.tcreate | time }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" header-align="center" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button v-if="scope.row.zstate === 1" type="text" size="small" @click="updatePicking(scope.row.sid, scope.row.rorder)">修改</el-button>
              <el-button v-if="scope.row.zstate === 1" type="text" size="small" class="red" @click="handleDelete(scope.row)">删除</el-button>
              <el-button v-if="scope.row.zstate === 2" type="text" size="small" @click="pickingShipment(scope.row.sid)">出货</el-button>
              <el-button v-if="scope.row.zstate === 2" type="text" size="small" style="color: rgb(234, 162, 148)" @click="handleBack(scope.row)">退回</el-button>
              <el-button v-if="scope.row.zstate === 2" type="text" size="small" class="red" @click="handleCancel(scope.row)">取消</el-button>
              <el-button v-if="scope.row.zstate === 3 || scope.row.zstate === 4 || scope.row.zstate === 5  || scope.row.zstate === 6" type="text" size="small" @click="pickingInfo(scope.row.sid)">详细</el-button>
              <el-button type="text" size="small" @click="handlePickLog(scope.row.sid)">操作记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="h50">
        <el-pagination :current-page="queryParams.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="queryParams.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <!--    弹窗-->
    <el-dialog class="elDialog" :close-on-click-modal="false" title="新增拣货单" :visible.sync="addPickingDialogVisible" width="1000px" append-to-body>
      <addPicking v-if="addPickingDialogVisible" @handleClose="handleClose" />
    </el-dialog>
    <el-dialog style="margin-top: -10vh;" class="elDialog" :close-on-click-modal="false" title="修改拣货单" :visible.sync="editPickingDialogVisible" width="1200px" append-to-body>
      <editPicking v-if="editPickingDialogVisible" :picking-id="checkSid" @handleClose="handleClose" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="拣货单出库" :visible.sync="pickingShipmentDialogVisible" width="1200px" append-to-body>
      <pickingShipment v-if="pickingShipmentDialogVisible" :sid="checkSid" @handleClose="handleClose" @handleUpdate="handleUpdate" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="拣货单详情" :visible.sync="pickingInfoDialogVisible" width="1200px" append-to-body>
      <pickingInfo v-if="pickingInfoDialogVisible" :sid="checkSid" @handleClose="handleClose" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="操作记录" :visible.sync="pickingLogDialogVisible" width="1200px" append-to-body>
      <pickingLog v-if="pickingLogDialogVisible" :pick-id="checkSid" @handleClose="handleClose" />
    </el-dialog>
  </div>
</template>
<script>
import addPicking from "@/views/order/dialog/addPicking.vue";
import editPicking from "@/views/order/dialog/editPicking.vue";
import pickingShipment from "@/views/order/dialog/pickingShipment.vue";
import pickingInfo from "@/views/order/dialog/pickingInfo.vue";
import pickingLog from "@/views/order/dialog/pickingLog.vue";
import { orderPickingState } from "@/utils/order";
import { formatTime } from "@/utils/utils";

export default {
  name: "OrderPicking",
  components: { addPicking, editPicking, pickingShipment, pickingInfo, pickingLog },
  filters: {
    time(value) {
      return formatTime(value);
    },
    orderPickingState(value) {
      return orderPickingState(value);
    },
  },
  data() {
    return {
      //模糊查询
      input: "",
      // 左侧树形
      filterText: "",
      storeList: [{ cname: "全部门店" }],
      defaultProps: {
        children: "children",
        label: "cname",
      },
      // 分页
      queryParams: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        storeId: "",
      },
      // 表格
      tableData: [],
      // 弹窗
      addPickingDialogVisible: false,
      editPickingDialogVisible: false,
      pickingShipmentDialogVisible: false,
      pickingInfoDialogVisible: false,
      pickingLogDialogVisible: false,
      // 选中id
      checkSid: "",
      ids: []
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.selectStoreList();
    this.queryPageList();
  },
  methods: {
    handlePickLog(sid) {
      this.checkSid = sid;
      this.pickingLogDialogVisible = true;
    },
    // 选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.sid);
    },
    toggleSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    handleUpdate(sid, rorder) {
      this.pickingShipmentDialogVisible = false;
      this.queryPageList();
      this.updatePicking(sid, rorder);
    },
    handleClose() {
      this.addPickingDialogVisible = false;
      this.editPickingDialogVisible = false;
      this.pickingShipmentDialogVisible = false;
      this.pickingInfoDialogVisible = false;
      this.queryPageList();
    },
    /**
     * 修改拣货单
     */
    updatePicking(sid, rorder) {
      this.checkSid = sid;
      this.topsAjax.get(`${this.baseUrls.ordPicking}/order/count/${rorder}`).then((res) => {
        if (res) {
          this.editPickingDialogVisible = true;
        } else {
          this.$message({
            message: "无法获取对应的订单号",
            type: "success",
          });
        }
      });
    },
    /**
     * 拣货单详细
     */
    pickingInfo(id) {
      this.pickingInfoDialogVisible = true;
      this.checkSid = id;
    },
    pickingShipment(id) {
      this.pickingShipmentDialogVisible = true;
      this.checkSid = id;
    },
    // 分页
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryPageList();
    },
    handleCurrentChange(val) {
      this.queryParams.currentPage = val;
      this.queryPageList();
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否删除当前记录？")
        .then((_) => {
          this.topsAjax.post(`${this.baseUrls.ordPicking}/deleteById`, { sid: row.sid }).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.queryPageList();
          });
        })
        .catch((_) => {});
    },
    // 退回
    handleBack(row) {
      this.$confirm("是否退回当前记录？")
        .then((_) => {
          this.topsAjax.post(`${this.baseUrls.ordPicking}/backById`, { sid: row.sid }).then((res) => {
            this.$message({
              message: "退回成功",
              type: "success",
            });
            this.queryPageList();
          });
        })
        .catch((_) => {});
    },
    handleCancelByIds() {
      if (this.ids.length === 0) {
        this.$message({
          message: "请选择需要取消的记录",
          type: "success",
        });
        return;
      }
      let idStrs = '';
      for (let i = 0; i < this.ids.length; i++) {
        if (idStrs.length > 0) {
          idStrs += ',';
        }
        idStrs += this.ids[i];
      }
      this.$confirm("是否批量取消当前选中记录？")
        .then((_) => {
          this.topsAjax.post(`${this.baseUrls.ordPicking}/cancelByIds`, { ids: idStrs }).then((res) => {
            this.$message({
              message: "批量取消成功",
              type: "success",
            });
            this.queryPageList();
          });
        })
        .catch((_) => {});
    },
    // 取消
    handleCancel(row) {
      this.$confirm("是否取消当前记录？")
        .then((_) => {
          this.topsAjax.post(`${this.baseUrls.ordPicking}/cancelById`, { sid: row.sid }).then((res) => {
            this.$message({
              message: "取消成功",
              type: "success",
            });
            this.queryPageList();
          });
        })
        .catch((_) => {});
    },
    // 拣货单查询
    queryPageList() {
      this.input = this.input.trim();
      let url = `${this.baseUrls.ordPicking}/queryPageList`;
      let params = this.queryParams;
      params.search = this.input;
      this.topsAjax.get(url, params).then((res) => {
        this.queryParams.total = res.total;
        this.tableData = res.list;
      });
    },
    // 左侧门店列表
    selectStoreList() {
      let url = `${this.baseUrls.orderStore}/queryList`;
      let params = {};
      this.topsAjax.get(url, params).then((res) => {
        this.storeList = this.storeList.concat(res);
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.cname.indexOf(value) !== -1;
    },
    handleNodeClick(node) {
      this.queryParams.currentPage = 1
      this.queryParams.pageSize = 10
      this.queryParams.total = 0
      this.queryParams.storeId = node.sid;
      this.queryPageList();
    },
  },
};
</script>

<style lang="scss" scoped>
.OrderPicking {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  padding: 3px;

  .el-divider--horizontal {
    margin: 10px 0;
  }

  &__left {
    margin-right: 20px;
    width: 15%;
    display: flex;
    flex-direction: column;
    background-color: white;
    box-shadow: 1px 1px 5px #888888;
    z-index: 100;
    position: relative;
  }

  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: white;
    box-shadow: 1px 1px 5px #888888;
    z-index: 100;
    position: relative;
    padding: 20px 10px;

    .el-radio-button__inner {
      width: auto;
    }
  }
}
</style>
